import { AppShell } from '@zyxantech/tux'
import { Outlet } from 'react-router-dom'
import { AppSidebar } from '@/components/layout/AppSidebar'
import { AppTopBar } from '@/components/layout/AppTopBar'
import { StatusBar } from '@/components/layout/StatusBar'
import { ErrorBoundary } from '@/components/shared/ErrorBoundary'
import { useSessionEnrichment } from '@/hooks/useSessionEnrichment'
import { useWebSocket } from '@/hooks/useWebSocket'

/**
 * Authenticated application frame: tux AppShell composes the sidebar + top bar;
 * a status strip and the routed page render in the content area. Session
 * enrichment (tenant name, permissions) and the realtime connection are started
 * here, once the shell mounts.
 */
export function AppLayout() {
  useSessionEnrichment()
  useWebSocket()

  return (
    <AppShell sidebar={<AppSidebar />} topbar={<AppTopBar />}>
      <div className="flex h-full flex-col">
        <StatusBar />
        <main className="flex-1 overflow-auto">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </AppShell>
  )
}
